export const PANEL_ID = {
  legend: "legend",
  viewOptions: "view-options",
  properties: "properties",
  selectedPerson: "selected-person",
};
